import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Loader from '../../../components/loader';
import Button from '../../../external/components/Button/Button';
import Text from '../../../external/components/Text/Text';
import { State } from '../../../reducers';
import { StakingSubgraphService } from '../../../services/staking/staking.subgraph.service';
import { StakingTransactionHistory } from '../../../services/staking/staking.types';
import { StakingTransactionCard } from '../components/StakingTransactionCard';
import { useNakedStakingPool } from '../hooks/usePool';
import { StakingScreenEnum } from './_Screens';

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<StakingScreenEnum>>;
}

const TabContainer = styled.div`
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  button:first-of-type {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  button:last-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  button:active {
    top: 0;
  }
`;

export function TransactionHistory({ setScreen }: Props) {
  const [stakingHistory, setStakingHistory] = useState<StakingTransactionHistory>();
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(1);

  const pool = useNakedStakingPool();
  const { walletAddress } = useSelector(({ account }: State) => ({
    walletAddress: account.address,
  }));

  const { networkId, stakingContractAddress, stakingTokenDecimals, stakingTokenSymbol } = pool;

  const init = useCallback(async () => {
    setLoading(true);
    try {
      const result = await StakingSubgraphService.getNakedStakingTransactionHistory({
        networkId,
        walletAddress,
        contractAddress: stakingContractAddress,
      });
      setStakingHistory(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setScreen(StakingScreenEnum.ERROR);
    }
  }, []);

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <Button
        size='small'
        variant='secondary'
        dark={true}
        onClick={() => setScreen(StakingScreenEnum.HOME_SCREEN)}
        disabled={loading}
      >
        ⬅
      </Button>
      <>
        {loading ? (
          <Loader />
        ) : (
          <>
            <TabContainer>
              <Button
                dark={true}
                onClick={() => setTab(1)}
                variant={tab === 1 ? 'primary' : 'secondary'}
              >
                Stakes
              </Button>
              <Button
                onClick={() => setTab(2)}
                dark={true}
                variant={tab === 2 ? 'primary' : 'secondary'}
              >
                Unstakes
              </Button>
              {/* <Button onClick={() => setTab(3)} dark={true} variant={tab === 3 ? 'primary' : 'secondary'}>
          Claims
        </Button> */}
            </TabContainer>
            <br />
            {tab === 1 && (
              <>
                {stakingHistory && stakingHistory.stakes && stakingHistory.stakes.length > 0 ? (
                  <>
                    {stakingHistory.stakes.map(({ timestamp, stakedAmount, id }) => (
                      <StakingTransactionCard
                        timestamp={timestamp}
                        amount={stakedAmount}
                        id={id}
                        networkId={networkId}
                        symbol={stakingTokenSymbol}
                        tokenDecimals={stakingTokenDecimals}
                        key={id}
                        type='Staked'
                      ></StakingTransactionCard>
                    ))}
                  </>
                ) : (
                  <Text dark={true}>No stakes found</Text>
                )}
              </>
            )}

            {tab === 2 && (
              <>
                {stakingHistory && stakingHistory.unstakes && stakingHistory.unstakes.length > 0 ? (
                  <>
                    {stakingHistory.unstakes.map(({ timestamp, unstakedAmount, id }) => (
                      <StakingTransactionCard
                        timestamp={timestamp}
                        amount={unstakedAmount}
                        id={id}
                        networkId={networkId}
                        symbol={stakingTokenSymbol}
                        tokenDecimals={stakingTokenDecimals}
                        key={id}
                        type='Unstaked'
                      ></StakingTransactionCard>
                    ))}
                  </>
                ) : (
                  <Text dark={true}>No unstakes found</Text>
                )}
              </>
            )}
          </>
        )}
      </>
    </>
  );
}
